import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent {


  /*
    Inputs for custom button. It is possible to change the message, background color or text color.
  */


  @Input() color: string = ""; //bg color

  @Input() textColor: string = "";

  @Input() width: string = "";

  @Input() icon: string = "";

  @Input() disabled: false | true = false;

  @Input() iconPosition: 'left' | 'right' | undefined;
  @Input() iconSize: string = '24px';
  @Input() iconColor: string = "";
  @Input() addIconClasses = true;

  @Input() typeBtn: 'primary' | 'secondary' | 'terceary' = 'primary';
  @Input() message: string = '';

  get hasSvgIcon(): boolean {
    return !!this.icon && this.icon.endsWith('.svg');
  }

    getButtonClass(): Record<string, boolean> {
      return {
        'primary-btn': this.typeBtn === 'primary',
        'secondary-btn': this.typeBtn === 'secondary',
        'terceary-btn': this.typeBtn === 'terceary',
        'no-background': this.hasSvgIcon,
        'button-container': this.hasSvgIcon,
        'disabled': this.disabled,
      };
    }


}


